import React from 'react';
import './PartnerStoriesHero.css';

const PartnerStoriesHero = () => {
  const scrollToContent = () => {
    const target = document.querySelector('.cst-content-area');
    if (target) {
      const topOffset = target.getBoundingClientRect().top + window.scrollY - 100;
      window.scrollTo({ top: topOffset, behavior: 'smooth' });
    }
  };

  return (
    <section className='cs-hero-section'>
      <div className='cs-hero-bg-text-container'>
        <div className='cs-hero-bg-text'>PARTNER STORIES</div>
        <div className='cs-hero-bg-text'>PARTNER STORIES</div>
      </div>

      <div className='cs-hero-card'>
        <div className='cs-hero-card-header'>
          <h1 className='cs-hero-title'>PARTNER STORIES</h1>
          <div className='cs-hero-icon'>
            <svg
              width='32'
              height='32'
              viewBox='0 0 32 32'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path
                d='M2 16C2 19.713 3.475 23.274 6.10051 25.8995C8.72601 28.525 12.287 30 16 30C19.713 30 23.274 28.525 25.8995 25.8995C28.525 23.274 30 19.713 30 16C30 12.287 28.525 8.72601 25.8995 6.10051C23.274 3.475 19.713 2 16 2C12.287 2 8.72601 3.475 6.10051 6.10051C3.475 8.72601 2 12.287 2 16Z'
                stroke='#171717'
                strokeWidth='2'
                strokeLinejoin='round'
              />
              <path
                d='M10 16C10 12.287 10.6321 8.72601 11.7574 6.10051C12.8826 3.475 14.4087 2 16 2C17.5913 2 19.1174 3.475 20.2426 6.10051C21.3679 8.72601 22 12.287 22 16C22 19.713 21.3679 23.274 20.2426 25.8995C19.1174 28.525 17.5913 30 16 30C14.4087 30 12.8826 28.525 11.7574 25.8995C10.6321 23.274 10 19.713 10 16Z'
                stroke='#171717'
                strokeWidth='2'
                strokeLinejoin='round'
              />
              <path
                d='M3 20.6712H29M3 11.3379H29'
                stroke='#171717'
                strokeWidth='2'
                strokeLinecap='round'
              />
            </svg>
          </div>
        </div>
        <p className='cs-hero-desc'>
          Real work, real results. Take a look at what we've built with our brand partners.
        </p>

        <div className='cs-hero-arrow-wrapper'>
          <div className='cs-hero-arrow' onClick={scrollToContent}>
            <svg viewBox='0 0 24 24' fill='none' stroke='#1c1c1c' strokeWidth='0.5'>
              <line x1='12' y1='5' x2='12' y2='19' />
              <polyline points='19 12 12 19 5 12' />
            </svg>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PartnerStoriesHero;
